import { render, staticRenderFns } from "./score.vue?vue&type=template&id=f660ddce&"
import script from "./score.vue?vue&type=script&lang=js&"
export * from "./score.vue?vue&type=script&lang=js&"
import style0 from "./score.vue?vue&type=style&index=0&id=f660ddce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports